module.exports = __webpack_public_path__ + "svg/roulette-opener.svg?acb71877f2cf0629cc292307ec335e11";